export default "__VITE_ASSET__985310d2__"